import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.removeItem("td_token");
    api.me()
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.login({ email, password });
    setUser(res.user);
    return res.user;
  };

  const register = async (payload) => {
    const res = await api.register(payload);
    if (!res.email_verification_required) setUser(res.user);
    return res;
  };

  const logout = async () => {
    try {
      await api.logout();
    } finally {
      localStorage.removeItem("td_token");
      setUser(null);
    }
  };

  const updateCurrentUser = (nextUser) => setUser(nextUser);

  // Memoize context value to avoid re-rendering all consumers on every render.
  const value = useMemo(
    () => ({ user, loading, login, register, logout, updateCurrentUser }),
    [user, loading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
